import { AdminFeeType } from 'application-types';
import { isNumberTwoDecimalPlaces } from './isNumberTwoDecimalPlaces';

export function isAdminFeeValueValid(adminFee: AdminFeeType): boolean {
  if (adminFee.value === '') {
    return false;
  }

  const numValue = Number(adminFee.value);

  if (numValue < 0) {
    return false;
  }

  return isNumberTwoDecimalPlaces(parseFloat(adminFee.value));
}
